/* eslint-disable no-loop-func */
import { params } from "../redux/reducers/reducer";
import { const_var } from "../redux/reducers/reducer";
import { revertPosOfCmp } from "./Functions";

export const wallNameArrForValid = [
    ['c_b_f_w', 'c_b_l_s_f_w', 'c_b_r_s_f_w', 'F_L_B_S_W'],
    ['c_b_b_w', 'c_b_l_s_b_w', 'c_b_r_s_b_w', 'B_L_B_S_W'],
    ['c_b_l_w', 'c_b_l_s_w', 'L_L_R_S_W', 'c_b_f_s_l_w'],
    ['c_b_r_w', 'c_b_r_s_w', 'R_L_L_S_W', 'c_b_f_s_r_w'],
    ['c_b_f_s_b_w'],
    ['c_b_f_s_w'],
    ['c_b_l_s_r_w'],
    ['c_b_r_s_l_w'],
    ['F_L_R_W'],
    ['F_L_F_W', 'F_L_F_S_W'],
    ['F_L_L_W'],
    ['F_L_R_S_W'],
    ['L_L_F_W'],
    ['L_L_L_W', 'L_L_L_S_W'],
    ['L_L_B_W'],
    ['L_L_F_S_W'],
    ['R_L_F_W'],
    ['R_L_R_W', 'R_L_R_S_W'],
    ['R_L_B_W'],
    ['R_L_F_S_W'],
    ['B_L_F_W'],
    ['B_L_S_W', 'B_L_F_S_W'],
    ['B_L_B_W'],
    ['B_L_L_S_W'],
]


export const addValidation = ({ compType, compName, width, height, wallName, parentkey, childkey, nestedkey, checkType, checkableDoorArr }) => {
    // console.log('giorgi- add validation -> ', { compType, compName, width, height, wallName, parentkey, childkey, nestedkey, checkType, checkableDoorArr });
    const componentDistance = const_var.componentDistance;
    
    let isAdd = false;
    let positionX = 0;
    let positionY = 0;
    
    const alpha = Math.atan(params.p_r_p / 12);
    const frontLeanAlpha = Math.atan(params.b_l_t_r_pF / 12);
    const backLeanAlpha = Math.atan(params.b_l_t_r_pB / 12);
    const leftLeanAlpha = Math.atan(params.b_l_t_r_p / 12);
    const rightLeanAlpha = Math.atan(params.b_l_t_r_pR / 12);
    const trimHeight = 0;
    let regularHeight = 0;
    let trimThickness = 0.2;

    if (params.p_r_s === 1) {
        trimThickness = 0.2;
        regularHeight = 0.4;
    } else if (params.p_r_s === 2) {
        trimThickness = 0.2;
        regularHeight = 0;
    } else if (params.p_r_s === 3) {
        trimThickness = 0.05;
        regularHeight = 0;
    }

    let trimOffsetHeight = 0;
    if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w' || wallName === 'c_b_l_s_w' ||
        wallName === 'F_L_F_W' || wallName === 'F_L_F_S_W' ||
        wallName === 'B_L_S_W' || wallName === 'B_L_F_S_W' ||
        wallName === 'L_L_L_W' || wallName === 'L_L_L_S_W' ||
        wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W' ||
        wallName === 'c_b_l_s_r_w' ||
        wallName === 'c_b_r_s_l_w'
    ) {
        trimOffsetHeight = trimThickness;
    } else {
        trimOffsetHeight = (params.p_r_p / 12) * trimThickness;
    }

    trimOffsetHeight = 0 

    /********** y - limit **********/
    let topPos = params.p_h;
    let bottomPos = 0;

    const bottomWindowValue = (const_var.focusedSection != undefined && const_var.focusedSection == "center") ? height / 2 + componentDistance : 0.5 + componentDistance;
    // const bottomWindowValue = 0.5 + componentDistance;

    if (params.singleSlope) {
        if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                topPos = params.p_h - trimHeight - Math.tan(alpha) * (width + componentDistance * 2)
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_l_s_w') {
                topPos = params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight - trimOffsetHeight
            } else if (wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w') {
                topPos = params.p_h - trimHeight - trimOffsetHeight
            } else if (wallName === 'c_b_l_s_r_w') {
                topPos = params.p_h - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075) * params.p_r_p / 12
            } else if (wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w') {
                topPos = params.p_h - trimHeight - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075) * params.p_r_p / 12 - Math.tan(alpha) * (width + componentDistance * 2)
            } else if (wallName === 'c_b_r_s_l_w') {
                topPos = params.p_h - (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12
            } else if (wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
                topPos = params.p_h - trimHeight - Math.tan(alpha) * (width + componentDistance * 2)
            }
            else if (wallName === 'R_L_F_W' || wallName === 'R_L_B_W' || wallName === 'R_L_F_S_W') {
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - Math.tan(rightLeanAlpha) * (width + componentDistance * 2)
            } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
                topPos = params.leanR_p_h - trimHeight - trimOffsetHeight
            }else if (wallName === 'R_L_L_S_W') {
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w
            } else if (wallName === 'L_L_R_S_W') {
                topPos = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w
            } 
        } else {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                bottomPos = bottomWindowValue;
                topPos = params.p_h - trimHeight - Math.tan(alpha) * (width + componentDistance * 2) - height / 2;
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_l_s_w') {
                bottomPos = bottomWindowValue;
                topPos = params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight - trimOffsetHeight - height / 2 - componentDistance;
            } else if (wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w') {
                bottomPos = bottomWindowValue;
                topPos = params.p_h - trimHeight - trimOffsetHeight - height / 2 - componentDistance;
            } else if (wallName === 'c_b_l_s_r_w') {
                bottomPos = bottomWindowValue;
                topPos = params.p_h - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075) * params.p_r_p / 12 - height / 2 - componentDistance;
            } else if (wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w') {
                bottomPos = bottomWindowValue;
                topPos = params.p_h - trimHeight - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075) * params.p_r_p / 12 - Math.tan(alpha) * (width + componentDistance * 2) - height / 2;
            } else if (wallName === 'c_b_r_s_l_w') {
                bottomPos = bottomWindowValue;
                topPos = params.p_h - (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 - height / 2 - componentDistance;
            } else if (wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
                bottomPos = bottomWindowValue;
                topPos = params.p_h - trimHeight - Math.tan(alpha) * (width + componentDistance * 2) - height / 2;
            }
            else if (wallName === 'R_L_F_W' || wallName === 'R_L_B_W' || wallName === 'R_L_F_S_W') {
                bottomPos = bottomWindowValue
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - Math.tan(rightLeanAlpha) * (width + componentDistance * 2) - height / 2
            } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
                bottomPos = bottomWindowValue
                topPos = params.leanR_p_h - trimHeight - trimOffsetHeight - height / 2 - componentDistance
            }
             else if (wallName === 'R_L_L_S_W') {
                bottomPos = bottomWindowValue
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w - height / 2 - componentDistance
            }
        }
    } else {
        if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                topPos = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance)
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w' || wallName === 'c_b_l_s_w') {
                topPos = params.p_h - trimHeight - trimOffsetHeight
            } else if (wallName === 'F_L_R_W' || wallName === 'F_L_L_W' || wallName === 'F_L_R_S_W') {
                topPos = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight - Math.tan(frontLeanAlpha) * (width + componentDistance * 2)
            } else if (wallName === 'F_L_F_W' || wallName === 'F_L_F_S_W') {
                topPos = params.leanF_p_h - trimHeight - trimOffsetHeight
            } else if (wallName === 'B_L_F_W' || wallName === 'B_L_B_W' || wallName === 'B_L_L_S_W') {
                topPos = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight - Math.tan(backLeanAlpha) * (width + componentDistance * 2)
            } else if (wallName === 'B_L_S_W' || wallName === 'B_L_F_S_W') {
                topPos = params.leanB_p_h - trimHeight - trimOffsetHeight
            } else if (wallName === 'R_L_F_W' || wallName === 'R_L_B_W' || wallName === 'R_L_F_S_W') {
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - Math.tan(rightLeanAlpha) * (width + componentDistance * 2)
            } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
                topPos = params.leanR_p_h - trimHeight - trimOffsetHeight
            } else if (wallName === 'L_L_F_W' || wallName === 'L_L_B_W' || wallName === 'L_L_F_S_W') {
                topPos = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight - Math.tan(leftLeanAlpha) * (width + componentDistance * 2)
            } else if (wallName === 'L_L_L_W' || wallName === 'L_L_L_S_W') {
                topPos = params.lean_p_h - trimHeight - trimOffsetHeight
            } else if (wallName === 'c_b_l_s_r_w') {
                let overHeight = 0;
                if (parseInt(params.cB_addStorage_left) < params.p_w / 2) {
                    if (params.p_r_s === 1) {
                        overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                    }
                } else {
                    if (params.p_r_s === 1) {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                    }
                }
                
                
                topPos = params.p_h + overHeight
            } else if (wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w') {
                if (parseInt(params.cB_addStorage_left) - params.p_w / 2 < width / 2 + componentDistance) {
                    topPos = params.p_h + (params.p_r_p / 12) * parseInt(params.cB_addStorage_left) + regularHeight - trimHeight - Math.tan(alpha) * (width + componentDistance * 2)
                } else {
                    topPos = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance)
                }
            } else if (wallName === 'c_b_r_s_l_w') {
                let overHeight = 0;
                if (parseInt(params.cB_addStorage_right) < params.p_w / 2) {
                    if (params.p_r_s === 1) {
                        overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                    }
                } else {
                    if (params.p_r_s === 1) {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                    }
                }
    
                topPos = params.p_h + overHeight
            } else if (wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
                if (parseInt(params.cB_addStorage_right) - params.p_w / 2 < width / 2 + componentDistance) {
                    topPos = params.p_h + (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) + regularHeight - trimHeight - Math.tan(alpha) * (width + componentDistance * 2)
                } else {
                    topPos = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance)
                }
            } else if (wallName === 'R_L_L_S_W') {
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w
            } else if (wallName === 'L_L_R_S_W') {
                topPos = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w
            }
        } else {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                bottomPos = bottomWindowValue
                topPos = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance) - height / 2
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w' || wallName === 'c_b_l_s_w') {
                bottomPos = bottomWindowValue
                topPos = params.p_h - trimHeight - trimOffsetHeight - height / 2 - componentDistance
            } else if (wallName === 'F_L_R_W' || wallName === 'F_L_L_W' || wallName === 'F_L_R_S_W') {
                bottomPos = bottomWindowValue
                topPos = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight - Math.tan(frontLeanAlpha) * (width + componentDistance * 2) - height / 2
            } else if (wallName === 'F_L_F_W' || wallName === 'F_L_F_S_W') {
                bottomPos = bottomWindowValue
                topPos = params.leanF_p_h - trimHeight - trimOffsetHeight - height / 2 - componentDistance
            } else if (wallName === 'B_L_F_W' || wallName === 'B_L_B_W' || wallName === 'B_L_L_S_W') {
                bottomPos = bottomWindowValue
                topPos = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight - Math.tan(backLeanAlpha) * (width + componentDistance * 2) - height / 2
            } else if (wallName === 'B_L_S_W' || wallName === 'B_L_F_S_W') {
                bottomPos = bottomWindowValue
                topPos = params.leanB_p_h - trimHeight - trimOffsetHeight - height / 2 - componentDistance
            } else if (wallName === 'R_L_F_W' || wallName === 'R_L_B_W' || wallName === 'R_L_F_S_W') {
                bottomPos = bottomWindowValue
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - Math.tan(rightLeanAlpha) * (width + componentDistance * 2) - height / 2
            } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
                bottomPos = bottomWindowValue
                topPos = params.leanR_p_h - trimHeight - trimOffsetHeight - height / 2 - componentDistance
            } else if (wallName === 'L_L_F_W' || wallName === 'L_L_B_W' || wallName === 'L_L_F_S_W') {
                bottomPos = bottomWindowValue
                topPos = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight - Math.tan(leftLeanAlpha) * (width + componentDistance * 2) - height / 2
            } else if (wallName === 'L_L_L_W' || wallName === 'L_L_L_S_W') {
                bottomPos = bottomWindowValue
                topPos = params.lean_p_h - trimHeight - trimOffsetHeight - height / 2 - componentDistance
            } else if (wallName === 'c_b_l_s_r_w') {
                let overHeight = 0;
                if (parseInt(params.cB_addStorage_left) < params.p_w / 2) {
                    if (params.p_r_s === 1) {
                        overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                    }
                } else {
                    if (params.p_r_s === 1) {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                    }
                }
    
                bottomPos = bottomWindowValue
                topPos = params.p_h + overHeight - height / 2 - componentDistance
            } else if (wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w') {
                if (parseInt(params.cB_addStorage_left) - params.p_w / 2 < width / 2 + componentDistance) {
                    bottomPos = bottomWindowValue
                    topPos = params.p_h + (params.p_r_p / 12) * parseInt(params.cB_addStorage_left) + regularHeight - trimHeight - Math.tan(alpha) * (width + componentDistance * 2) - height / 2
                } else {
                    bottomPos = bottomWindowValue
                    topPos = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance) - height / 2
                }
            } else if (wallName === 'c_b_r_s_l_w') {
                let overHeight = 0;
                if (parseInt(params.cB_addStorage_right) < params.p_w / 2) {
                    if (params.p_r_s === 1) {
                        overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                    }
                } else {
                    if (params.p_r_s === 1) {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                    }
                }
    
                bottomPos = bottomWindowValue
                topPos = params.p_h + overHeight - height / 2 - componentDistance
            } else if (wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
                if (parseInt(params.cB_addStorage_right) - params.p_w / 2 < width / 2 + componentDistance) {
                    bottomPos = bottomWindowValue
                    topPos = params.p_h + (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) + regularHeight - trimHeight - Math.tan(alpha) * (width + componentDistance * 2) - height / 2
                } else {
                    bottomPos = bottomWindowValue
                    topPos = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance) - height / 2
                }
            } else if (wallName === 'R_L_L_S_W') {
                bottomPos = bottomWindowValue
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w - height / 2 - componentDistance
            } else if (wallName === 'L_L_R_S_W') {
                bottomPos = bottomWindowValue
                topPos = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w - height / 2 - componentDistance
            }
        }
    }
    /********** y - limit **********/
    
    const clearance = const_var.newComponentArray[parentkey][childkey][nestedkey]['Size'][`${width}x${height}`];
    const isEndSide = const_var.entry_wall_location[wallName];

    if (clearance && (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout")) {
        if (isEndSide.includes('end') && clearance.end_clearance) {
            topPos -= clearance.end_clearance;
        } else if (clearance.side_clearance) {
            topPos -= clearance.side_clearance;
        }
    }
    
    /********** calculate position x, y **********/
    const count = Math.floor((topPos - bottomPos - 1.5) / 0.1);

    let minLimitX, maxLimitX = 0;

    const newArray = [...const_var.newDoorsArray];
    
    const targetWallNameArr = wallNameArrForValid.find(subArray => subArray.includes(wallName));
    const doorsArray = checkType === 'update_check' ? [...checkableDoorArr] : [...const_var.newDoorsArray];
    
    revertPosOfCmp(doorsArray, wallName)
    
    for (let i = 0; i <= count; i++) {
        /********** calculate position y **********/
        if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
            positionY = height / 2;
        } else {
            positionY = bottomPos + 1.5 + i * 0.1;
        }
        /********** calculate position y **********/

        /********** x - limit **********/
        let leftPos = 0;
        let rightPos = 0;
    
        if (params.singleSlope) {
            if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
                if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w') {
                    const maxHeight = params.p_h - trimHeight;
                    if (height <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                        leftPos = -(params.p_w / 2)
                        rightPos = params.p_w / 2
                    } else {
                        const minValue = -params.p_w / 2 + (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = params.p_w / 2
                    }
                } else if (wallName === 'c_b_b_w') {
                    const maxHeight = params.p_h - trimHeight;
                    if (height <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                        leftPos = -(params.p_w / 2)
                        rightPos = params.p_w / 2
                    } else {
                        const minValue = params.p_w / 2 - (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -params.p_w / 2
                        rightPos = -minValue
                    }
                } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_l_w') {
                    leftPos = -(params.p_d / 2)
                    rightPos = params.p_d / 2
                } else if (wallName === 'c_b_r_s_w') {
                    leftPos = -(parseInt(params.p_u_t) - params.p_d / 2)
                    rightPos = params.p_d / 2
                } else if (wallName === 'c_b_l_s_w') {
                    leftPos = -(params.p_d / 2)
                    rightPos = parseInt(params.p_u_t) - params.p_d / 2
                } else if (wallName === 'c_b_l_s_f_w') {
                    const maxHeight = params.p_h - trimHeight;
                    if (height <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                        leftPos = -(params.p_w / 2)
                        rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                    } else {
                        const minValue = -params.p_w / 2 + (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                    }
                } else if (wallName === 'c_b_l_s_b_w') {
                    const maxHeight = params.p_h - trimHeight;
                    if (height <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                        leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                        rightPos = params.p_w / 2
                    } else {
                        const minValue = params.p_w / 2 - (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                        rightPos = -minValue
                    }
                } else if (wallName === 'c_b_r_s_f_w') {
                    const maxHeight = params.p_h - trimHeight;
                    if (height <= params.p_h - (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) - trimHeight) {
                        leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_right)
                        rightPos = params.p_w / 2
                    } else {
                        const minValue = -params.p_w / 2 + (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = params.p_w / 2
                    }
                } else if (wallName === 'c_b_r_s_b_w') {
                    const maxHeight = params.p_h - trimHeight;
                    if (height <= params.p_h - (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) - trimHeight) {
                        leftPos = -(params.p_w / 2)
                        rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_right)
                    } else {
                        const minValue = params.p_w / 2 - (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -params.p_w / 2
                        rightPos = -minValue
                    }
                }
                else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                    const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                    if (height <= params.leanR_p_h + regularHeight - trimHeight) {
                        leftPos = params.p_w / 2
                        rightPos = params.p_w / 2 + params.leanR_p_w
                    } else {
                        const minValue = (maxHeight - height) / Math.tan(rightLeanAlpha);
                        leftPos = params.p_w / 2
                        rightPos = params.p_w / 2 + minValue
                    }
                } else if (wallName === 'R_L_B_W') {
                    const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                    if (height <= params.leanR_p_h + regularHeight - trimHeight) {
                        leftPos = -params.p_w / 2 - params.leanR_p_w
                        rightPos = -params.p_w / 2
                    } else {
                        const minValue = (maxHeight - height) / Math.tan(rightLeanAlpha);
                        leftPos = -params.p_w / 2 - minValue
                        rightPos = -params.p_w / 2
                    }
                }
                else if (wallName === 'R_L_R_W') {
                    leftPos = -params.add_right_front_lean_porch ? params.leanR_p_pos - params.leanR_p_d / 2 - params.leanF_p_w : -params.leanR_p_pos - params.leanR_p_d / 2
                    rightPos = -params.add_right_back_lean_porch ? params.leanR_p_pos + params.leanR_p_d / 2 + params.leanB_p_w : -params.leanR_p_pos + params.leanR_p_d / 2
                }else if (wallName === 'R_L_R_S_W') {
                    leftPos = -params.leanR_p_pos + params.leanR_p_d / 2 - parseInt(params.add_storage_right)
                    rightPos = -params.leanR_p_pos + params.leanR_p_d / 2
                } else if (wallName === 'R_L_L_S_W') {
                    leftPos = params.leanR_p_pos - params.leanR_p_d / 2
                    rightPos = params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right)
                }

                
            } else {
                if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w') {
                    const maxHeight = params.p_h - trimHeight;
                    if (positionY + height / 2 <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                        leftPos = -(params.p_w / 2)
                        rightPos = params.p_w / 2
                    } else {
                        const minValue = -params.p_w / 2 + (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = params.p_w / 2
                    }
                } else if (wallName === 'c_b_b_w') {
                    const maxHeight = params.p_h - trimHeight;
                    if (positionY + height / 2 <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                        leftPos = -(params.p_w / 2)
                        rightPos = params.p_w / 2
                    } else {
                        const minValue = params.p_w / 2 - (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -params.p_w / 2
                        rightPos = -minValue
                    }
                } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_l_w') {
                    leftPos = -(params.p_d / 2)
                    rightPos = params.p_d / 2
                } else if (wallName === 'c_b_r_s_w') {
                    leftPos = -(parseInt(params.p_u_t) - params.p_d / 2)
                    rightPos = params.p_d / 2
                } else if (wallName === 'c_b_l_s_w') {
                    leftPos = -(params.p_d / 2)
                    rightPos = parseInt(params.p_u_t) - params.p_d / 2
                } else if (wallName === 'c_b_l_s_f_w') {
                    const maxHeight = params.p_h - trimHeight;
                    if (positionY + height / 2 <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                        leftPos = -(params.p_w / 2)
                        rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                    } else {
                        const minValue = -params.p_w / 2 + (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                    }
                } else if (wallName === 'c_b_l_s_b_w') {
                    const maxHeight = params.p_h - trimHeight;
                    if (positionY + height / 2 <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                        leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                        rightPos = params.p_w / 2
                    } else {
                        const minValue = params.p_w / 2 - (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                        rightPos = -minValue
                    }
                } else if (wallName === 'c_b_r_s_f_w') {
                    const maxHeight = params.p_h - trimHeight;
                    if (positionY + height / 2 <= params.p_h - (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) - trimHeight) {
                        leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_right)
                        rightPos = params.p_w / 2
                    } else {
                        const minValue = -params.p_w / 2 + (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = params.p_w / 2
                    }
                } else if (wallName === 'c_b_r_s_b_w') {
                    const maxHeight = params.p_h - trimHeight;
                    if (positionY + height / 2 <= params.p_h - (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) - trimHeight) {
                        leftPos = -(params.p_w / 2)
                        rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_right)
                    } else {
                        const minValue = params.p_w / 2 - (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -params.p_w / 2
                        rightPos = -minValue
                    }
                }
                else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                    const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                    if (positionY + height / 2 <= params.leanR_p_h + regularHeight - trimHeight) {
                        leftPos = params.p_w / 2
                        rightPos = params.p_w / 2 + params.leanR_p_w
                    } else {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(rightLeanAlpha);
                        leftPos = params.p_w / 2
                        rightPos = params.p_w / 2 + minValue
                    }
                } else if (wallName === 'R_L_B_W') {
                    const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                    if (positionY + height / 2 <= params.leanR_p_h + regularHeight - trimHeight) {
                        leftPos = -params.p_w / 2 - params.leanR_p_w
                        rightPos = -params.p_w / 2
                    } else {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(rightLeanAlpha);
                        leftPos = -params.p_w / 2 - minValue
                        rightPos = -params.p_w / 2
                    }
                }
                else if (wallName === 'R_L_R_W') {
                    leftPos = -params.add_right_front_lean_porch ? params.leanR_p_pos - params.leanR_p_d / 2 - params.leanF_p_w : -params.leanR_p_pos - params.leanR_p_d / 2
                    rightPos = -params.add_right_back_lean_porch ? params.leanR_p_pos + params.leanR_p_d / 2 + params.leanB_p_w : -params.leanR_p_pos + params.leanR_p_d / 2
                } else if (wallName === 'R_L_R_S_W') {
                    leftPos = -params.leanR_p_pos + params.leanR_p_d / 2 - parseInt(params.add_storage_right)
                    rightPos = -params.leanR_p_pos + params.leanR_p_d / 2
                } else if (wallName === 'R_L_L_S_W') {
                    leftPos = params.leanR_p_pos - params.leanR_p_d / 2
                    rightPos = params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right)
                }
            }
        } else {
            if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
                if(wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                    const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight ;
                    if (height <= params.p_h + regularHeight - trimHeight) {
                        leftPos = -(params.p_w / 2)
                        rightPos = params.p_w / 2
                    } else {
                        const minValue = (maxHeight - height) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = minValue
                    }
                } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_l_w') {
                    leftPos = -params.p_d / 2
                    rightPos = params.p_d / 2
                } else if (wallName === 'F_L_R_W' || wallName === 'F_L_R_S_W') {
                    const maxHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight;
                    if (height <= params.leanF_p_h + regularHeight - trimHeight) {
                        leftPos = -params.p_d / 2 - 0.15 - params.leanF_p_w
                        rightPos = -params.p_d / 2 - 0.15
                    } else {
                        const minValue = (maxHeight - height) / Math.tan(frontLeanAlpha);
                        leftPos = -params.p_d / 2 - 0.15 - minValue
                        rightPos = -params.p_d / 2 - 0.15
                    }
                } else if (wallName === 'F_L_L_W') {
                    const maxHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight;
                    if (height <= params.leanF_p_h + regularHeight - trimHeight) {
                        leftPos = params.p_d / 2 + 0.15
                        rightPos = params.p_d / 2 + 0.15+ params.leanF_p_w
                    } else {
                        const minValue = (maxHeight - height) / Math.tan(frontLeanAlpha);
                        leftPos = params.p_d / 2 + 0.15
                        rightPos = params.p_d / 2 + 0.15 + minValue
                    }
                } else if (wallName === 'F_L_F_W') {
                    leftPos = params.add_left_front_lean_porch ? params.leanF_p_pos - params.leanF_p_d / 2 - params.lean_p_w : params.leanF_p_pos - params.leanF_p_d / 2
                    rightPos = params.add_right_front_lean_porch ? params.leanF_p_pos + params.leanF_p_d / 2 + params.leanR_p_w : params.leanF_p_pos + params.leanF_p_d / 2
                } else if (wallName === 'B_L_F_W' || wallName === 'B_L_L_S_W') {
                    const maxHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight;
                    if (height <= params.leanB_p_h + regularHeight - trimHeight) {
                        leftPos = params.p_d / 2 + 0.15
                        rightPos = params.p_d / 2 + 0.15 + params.leanB_p_w
                    } else {
                        const minValue = (maxHeight - height) / Math.tan(backLeanAlpha);
                        leftPos = params.p_d / 2 + 0.15
                        rightPos = params.p_d / 2 + 0.15 + minValue
                    }
                } else if (wallName === 'B_L_B_W') {
                    const maxHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight;
                    if (height <= params.leanB_p_h + regularHeight - trimHeight) {
                        leftPos = -params.p_d / 2 - 0.15 - params.leanB_p_w
                        rightPos = -params.p_d / 2 - 0.15
                    } else {
                        const minValue = (maxHeight - height) / Math.tan(backLeanAlpha);
                        leftPos = -params.p_d / 2 - 0.15 - minValue
                        rightPos = -params.p_d / 2 - 0.15
                    }
                } else if (wallName === 'B_L_S_W') {
                    leftPos = params.add_right_back_lean_porch ? -params.leanB_p_pos - params.leanB_p_d / 2 - params.leanR_p_w : -params.leanB_p_pos - params.leanB_p_d / 2
                    rightPos = params.add_left_back_lean_porch ? -params.leanB_p_pos + params.leanB_p_d / 2 + params.lean_p_w : -params.leanB_p_pos + params.leanB_p_d / 2
                } else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                    const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                    if (height <= params.leanR_p_h + regularHeight - trimHeight) {
                        leftPos = params.p_w / 2
                        rightPos = params.p_w / 2 + params.leanR_p_w
                    } else {
                        const minValue = (maxHeight - height) / Math.tan(rightLeanAlpha);
                        leftPos = params.p_w / 2
                        rightPos = params.p_w / 2 + minValue
                    }
                } else if (wallName === 'R_L_B_W') {
                    const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                    if (height <= params.leanR_p_h + regularHeight - trimHeight) {
                        leftPos = -params.p_w / 2 - params.leanR_p_w
                        rightPos = -params.p_w / 2
                    } else {
                        const minValue = (maxHeight - height) / Math.tan(rightLeanAlpha);
                        leftPos = -params.p_w / 2 - minValue
                        rightPos = -params.p_w / 2
                    }
                } else if (wallName === 'R_L_R_W') {
                    leftPos = -params.add_right_front_lean_porch ? params.leanR_p_pos - params.leanR_p_d / 2 - params.leanF_p_w : -params.leanR_p_pos - params.leanR_p_d / 2
                    rightPos = -params.add_right_back_lean_porch ? params.leanR_p_pos + params.leanR_p_d / 2 + params.leanB_p_w : -params.leanR_p_pos + params.leanR_p_d / 2
                } else if (wallName === 'L_L_F_W' || wallName === 'L_L_F_S_W') {
                    const maxHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight;
                    if (height <= params.lean_p_h + regularHeight - trimHeight) {
                        leftPos = -params.p_w / 2 - params.lean_p_w
                        rightPos = -params.p_w / 2
                    } else {
                        const minValue = (maxHeight - height) / Math.tan(leftLeanAlpha);
                        leftPos = -params.p_w / 2 - minValue
                        rightPos = -params.p_w / 2
                    }
                } else if (wallName === 'L_L_B_W') {
                    const maxHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight;
                    if (height <= params.lean_p_h + regularHeight - trimHeight) {
                        leftPos = params.p_w / 2
                        rightPos = params.p_w / 2 + params.lean_p_w
                    } else {
                        const minValue = (maxHeight - height) / Math.tan(leftLeanAlpha);
                        leftPos = params.p_w / 2
                        rightPos = params.p_w / 2 + minValue
                    }
                } else if (wallName === 'L_L_L_W') {
                    leftPos = params.add_left_back_lean_porch ? params.lean_p_pos - params.lean_p_d / 2 - params.leanB_p_w : params.lean_p_pos - params.lean_p_d / 2
                    rightPos = params.add_left_front_lean_porch ? params.lean_p_pos + params.lean_p_d / 2 + params.leanF_p_w : params.lean_p_pos + params.lean_p_d / 2
                } else if (wallName === 'c_b_r_s_w') {
                    leftPos = -(parseInt(params.p_u_t) - params.p_d / 2)
                    rightPos = params.p_d / 2
                } else if (wallName === 'c_b_l_s_w') {
                    leftPos = -params.p_d / 2
                    rightPos = parseInt(params.p_u_t) - params.p_d / 2
                } else if (wallName === 'c_b_l_s_f_w') {
                    const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight ;
                    if (height <= params.p_h + regularHeight - trimHeight) {
                        leftPos = -params.p_w / 2
                        rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                    } else if (height <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_left) - params.p_w / 2)) {
                        const minValue = (maxHeight - height) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                    } else {
                        const minValue = (maxHeight - height) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = minValue
                    }
                } else if (wallName === 'c_b_l_s_b_w') {
                    const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight ;
                    if (height <= params.p_h + regularHeight - trimHeight) {
                        leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                        rightPos = params.p_w / 2
                    } else if (height <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_left) - params.p_w / 2)) {
                        const minValue = (maxHeight - height) / Math.tan(alpha);
                        leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                        rightPos = minValue
                    } else {
                        const minValue = (maxHeight - height) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = minValue
                    }
                } else if (wallName === 'c_b_r_s_f_w') {
                    const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight ;
                    if (height <= params.p_h + regularHeight - trimHeight) {
                        leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_right)
                        rightPos = params.p_w / 2
                    } else if (height <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_right) - params.p_w / 2)) {
                        const minValue = (maxHeight - height) / Math.tan(alpha);
                        leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_right)
                        rightPos = minValue
                    } else {
                        const minValue = (maxHeight - height) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = minValue
                    }
                } else if (wallName === 'c_b_r_s_b_w') {
                    const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight ;
                    if (height <= params.p_h + regularHeight - trimHeight) {
                        leftPos = -params.p_w / 2
                        rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_right)
                    } else if (height <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_right) - params.p_w / 2)) {
                        const minValue = (maxHeight - height) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_right)
                    } else {
                        const minValue = (maxHeight - height) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = minValue
                    }
                } else if (wallName === 'F_L_F_S_W') {
                    leftPos = params.leanF_p_pos - params.leanF_p_d / 2
                    rightPos = params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front)
                } else if (wallName === 'B_L_F_S_W') {
                    leftPos = -params.leanB_p_pos + params.leanB_p_d / 2 - parseInt(params.add_storage_back)
                    rightPos = -params.leanB_p_pos + params.leanB_p_d / 2
                } else if (wallName === 'R_L_R_S_W') {
                    leftPos = -params.leanR_p_pos + params.leanR_p_d / 2 - parseInt(params.add_storage_right)
                    rightPos = -params.leanR_p_pos + params.leanR_p_d / 2
                } else if (wallName === 'R_L_L_S_W') {
                    leftPos = params.leanR_p_pos - params.leanR_p_d / 2
                    rightPos = params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right)
                } else if (wallName === 'L_L_L_S_W') {
                    leftPos = params.lean_p_pos - params.lean_p_d / 2
                    rightPos = params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage)
                } else if (wallName === 'L_L_R_S_W') {
                    leftPos = -params.lean_p_pos + params.lean_p_d / 2 - parseInt(params.add_storage)
                    rightPos = -params.lean_p_pos + params.lean_p_d / 2
                }
            } else {
                if(wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                    const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight;
                    if (positionY + height / 2 <= params.p_h + regularHeight - trimHeight) {
                        leftPos = -(params.p_w / 2)
                        rightPos = params.p_w / 2
                    } else {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = minValue
                    }
                } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_l_w') {
                    leftPos = -params.p_d / 2
                    rightPos = params.p_d / 2
                } else if (wallName === 'F_L_R_W' || wallName === 'F_L_R_S_W') {
                    const maxHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight;
                    if (positionY + height / 2 <= params.leanF_p_h + regularHeight - trimHeight) {
                        leftPos = -params.p_d / 2 - 0.15 - params.leanF_p_w
                        rightPos = -params.p_d / 2 - 0.15
                    } else {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(frontLeanAlpha);
                        leftPos = -params.p_d / 2 - 0.15 - minValue
                        rightPos = -params.p_d / 2 - 0.15
                    }
                } else if (wallName === 'F_L_L_W') {
                    const maxHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight;
                    if (positionY + height / 2 <= params.leanF_p_h + regularHeight - trimHeight) {
                        leftPos = params.p_d / 2 + 0.15
                        rightPos = params.p_d / 2 + 0.15 + params.leanF_p_w
                    } else {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(frontLeanAlpha);
                        leftPos = params.p_d / 2 + 0.15
                        rightPos = params.p_d / 2 + 0.15 + minValue
                    }
                } else if (wallName === 'F_L_F_W') {
                    leftPos = params.add_left_front_lean_porch ? params.leanF_p_pos - params.leanF_p_d / 2 - params.lean_p_w : params.leanF_p_pos - params.leanF_p_d / 2
                    rightPos = params.add_right_front_lean_porch ? params.leanF_p_pos + params.leanF_p_d / 2 + params.leanR_p_w : params.leanF_p_pos + params.leanF_p_d / 2
                } else if (wallName === 'B_L_F_W' || wallName === 'B_L_L_S_W') {
                    const maxHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight;
                    if (positionY + height / 2 <= params.leanB_p_h + regularHeight - trimHeight) {
                        leftPos = params.p_d / 2 + 0.15
                        rightPos = params.p_d / 2 + 0.15 + params.leanB_p_w
                    } else {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(backLeanAlpha);
                        leftPos = params.p_d / 2 + 0.15
                        rightPos = params.p_d / 2 + 0.15 + minValue
                    }
                } else if (wallName === 'B_L_B_W') {
                    const maxHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight;
                    if (positionY + height / 2 <= params.leanB_p_h + regularHeight - trimHeight) {
                        leftPos = -params.p_d / 2 - 0.15 - params.leanB_p_w
                        rightPos = -params.p_d / 2 - 0.15
                    } else {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(backLeanAlpha);
                        leftPos = -params.p_d / 2 - 0.15 - minValue
                        rightPos = -params.p_d / 2 - 0.15
                    }
                } else if (wallName === 'B_L_S_W') {
                    leftPos = params.add_right_back_lean_porch ? -params.leanB_p_pos - params.leanB_p_d / 2 - params.leanR_p_w : -params.leanB_p_pos - params.leanB_p_d / 2
                    rightPos = params.add_left_back_lean_porch ? -params.leanB_p_pos + params.leanB_p_d / 2 + params.lean_p_w : -params.leanB_p_pos + params.leanB_p_d / 2
                } else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                    const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                    if (positionY + height / 2 <= params.leanR_p_h + regularHeight - trimHeight) {
                        leftPos = params.p_w / 2
                        rightPos = params.p_w / 2 + params.leanR_p_w
                    } else {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(rightLeanAlpha);
                        leftPos = params.p_w / 2
                        rightPos = params.p_w / 2 + minValue
                    }
                } else if (wallName === 'R_L_B_W') {
                    const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                    if (positionY + height / 2 <= params.leanR_p_h + regularHeight - trimHeight) {
                        leftPos = -params.p_w / 2 - params.leanR_p_w
                        rightPos = -params.p_w / 2
                    } else {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(rightLeanAlpha);
                        leftPos = -params.p_w / 2 - minValue
                        rightPos = -params.p_w / 2
                    }
                } else if (wallName === 'R_L_R_W') {
                    leftPos = -params.add_right_front_lean_porch ? params.leanR_p_pos - params.leanR_p_d / 2 - params.leanF_p_w : -params.leanR_p_pos - params.leanR_p_d / 2
                    rightPos = -params.add_right_back_lean_porch ? params.leanR_p_pos + params.leanR_p_d / 2 + params.leanB_p_w : -params.leanR_p_pos + params.leanR_p_d / 2
                } else if (wallName === 'L_L_F_W' || wallName === 'L_L_F_S_W') {
                    const maxHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight;
                    if (positionY + height / 2 <= params.lean_p_h + regularHeight - trimHeight) {
                        leftPos = -params.p_w / 2 - params.lean_p_w
                        rightPos = -params.p_w / 2
                    } else {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(leftLeanAlpha);
                        leftPos = -params.p_w / 2 - minValue
                        rightPos = -params.p_w / 2
                    }
                } else if (wallName === 'L_L_B_W') {
                    const maxHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight;
                    if (positionY + height / 2 <= params.lean_p_h + regularHeight - trimHeight) {
                        leftPos = params.p_w / 2
                        rightPos = params.p_w / 2 + params.lean_p_w
                    } else {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(leftLeanAlpha);
                        leftPos = params.p_w / 2
                        rightPos = params.p_w / 2 + minValue
                    }
                } else if (wallName === 'L_L_L_W') {
                    leftPos = params.add_left_back_lean_porch ? params.lean_p_pos - params.lean_p_d / 2 - params.leanB_p_w : params.lean_p_pos - params.lean_p_d / 2
                    rightPos = params.add_left_front_lean_porch ? params.lean_p_pos + params.lean_p_d / 2 + params.leanF_p_w : params.lean_p_pos + params.lean_p_d / 2
                } else if (wallName === 'c_b_r_s_w') {
                    leftPos = -(parseInt(params.p_u_t) - params.p_d / 2)
                    rightPos = params.p_d / 2
                } else if (wallName === 'c_b_l_s_w') {
                    leftPos = -params.p_d / 2
                    rightPos = parseInt(params.p_u_t) - params.p_d / 2
                } else if (wallName === 'c_b_l_s_f_w') {
                    const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight;
                    if (positionY + height / 2 <= params.p_h + regularHeight - trimHeight) {
                        leftPos = -params.p_w / 2
                        rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                    } else if (positionY + height / 2 <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_left) - params.p_w / 2)) {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                    } else {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = minValue
                    }
                } else if (wallName === 'c_b_l_s_b_w') {
                    const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight;
                    if (positionY + height / 2 <= params.p_h + regularHeight - trimHeight) {
                        leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                        rightPos = params.p_w / 2
                    } else if (positionY + height / 2 <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_left) - params.p_w / 2)) {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                        rightPos = minValue
                    } else {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = minValue
                    }
                } else if (wallName === 'c_b_r_s_f_w') {
                    const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight;
                    if (positionY + height / 2 <= params.p_h + regularHeight - trimHeight) {
                        leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_right)
                        rightPos = params.p_w / 2
                    } else if (positionY + height / 2 <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_right) - params.p_w / 2)) {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_right)
                        rightPos = minValue
                    } else {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = minValue
                    }
                } else if (wallName === 'c_b_r_s_b_w') {
                    const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight;
                    if (positionY + height / 2 <= params.p_h + regularHeight - trimHeight) {
                        leftPos = -params.p_w / 2
                        rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_right)
                    } else if (positionY + height / 2 <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_right) - params.p_w / 2)) {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_right)
                    } else {
                        const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                        leftPos = -minValue
                        rightPos = minValue
                    }
                } else if (wallName === 'F_L_F_S_W') {
                    leftPos = params.leanF_p_pos - params.leanF_p_d / 2
                    rightPos = params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front)
                } else if (wallName === 'B_L_F_S_W') {
                    leftPos = -params.leanB_p_pos + params.leanB_p_d / 2 - parseInt(params.add_storage_back)
                    rightPos = -params.leanB_p_pos + params.leanB_p_d / 2
                } else if (wallName === 'R_L_R_S_W') {
                    leftPos = -params.leanR_p_pos + params.leanR_p_d / 2 - parseInt(params.add_storage_right)
                    rightPos = -params.leanR_p_pos + params.leanR_p_d / 2
                } else if (wallName === 'R_L_L_S_W') {
                    leftPos = params.leanR_p_pos - params.leanR_p_d / 2
                    rightPos = params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right)
                } else if (wallName === 'L_L_L_S_W') {
                    leftPos = params.lean_p_pos - params.lean_p_d / 2
                    rightPos = params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage)
                } else if (wallName === 'L_L_R_S_W') {
                    leftPos = -params.lean_p_pos + params.lean_p_d / 2 - parseInt(params.add_storage)
                    rightPos = -params.lean_p_pos + params.lean_p_d / 2
                }
            }
        }
        /********** x - limit **********/

        /********** calculate position x **********/
        const sideArray = doorsArray.filter((item) => 
            targetWallNameArr.includes(item.userData.wallName) && 
            item.positionX + item.width > leftPos && item.positionX - item.width < rightPos && 
            item.positionY - item.height / 2 < positionY + height / 2 + componentDistance && 
            item.positionY + item.height / 2 > positionY - height / 2 - componentDistance
        ).sort((a, b) => (a.positionX - a.width / 2) - (b.positionX - b.width / 2));
        // console.log('giorgi- addValidation _ sideArray: ', sideArray);
        

        
        if (sideArray.length === 0) {
            if (Math.abs(rightPos - leftPos) >= width + componentDistance * 2) {
                if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
                    if (topPos - bottomPos >= height) {
                        isAdd = true;
                    }
                } else {
                    if (topPos - bottomPos >= 0) {
                        isAdd = true;
                    }
                }

                if (isAdd) {
                    positionX = leftPos + (rightPos - leftPos) / 2;
                }
            }
        } else {
            if (((compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") && (topPos - bottomPos < height)) || 
                ((compType === "window" || compType === "window_frameout") && (topPos - bottomPos < 0))
            ) {
                isAdd = false;
            } else {
                let prevPos = leftPos;
                let round = 0;
                for (let item of sideArray) {
                    if (round === 0 && (item.positionX - item.width / 2) > rightPos) {
                        if(rightPos - prevPos >= (width + 2 * componentDistance)) {
                            positionX = prevPos + (rightPos - prevPos) / 2;
                            isAdd = true;
                            break;
                        } else {
                            break;
                        }
                    } else {
                        if((item.positionX - item.width / 2) - prevPos >= (width + 2 * componentDistance)) {
                            const tempPositionX = prevPos + ((item.positionX - item.width / 2) - prevPos) / 2;
                            const overlapVerticalCmp = sideArray.find(s => (
                                s.positionX - s.width / 2 < tempPositionX + width / 2 + componentDistance && 
                                s.positionX + s.width / 2 > tempPositionX - width / 2 - componentDistance &&
                                s.positionY - s.height / 2 < positionY + height / 2 + componentDistance && 
                                s.positionY + s.height / 2 > positionY - height / 2 - componentDistance  
                            ))

                            if (overlapVerticalCmp) {
                                prevPos = item.positionX + item.width / 2;
                            } else {

                                if (compType == "window" || compType == "window_frameout") {
                                    if (tempPositionX >= (leftPos + width/2 + componentDistance) && tempPositionX <= (rightPos - width/2 - componentDistance)) {
                                        positionX = tempPositionX;
                                        isAdd = true;
                                        break;
                                    }
                                } else {
                                    positionX = tempPositionX;
                                    isAdd = true;
                                    break;
                                }
                            }
                        } else {
                            prevPos = item.positionX + item.width / 2;
                        }
                    }
                    round++;
                }
            
                // console.log('giorgi- addValidation _ isAdd:___first -> ', isAdd);
                if (!isAdd) {
                    if (prevPos > leftPos) {
                        const maxPosValueOfEndCmp = sideArray.reduce((max, obj) => obj.positionX + obj.width / 2 > max ? obj.positionX + obj.width / 2 : max, sideArray[0].positionX + sideArray[0].width / 2);
                        if (prevPos < maxPosValueOfEndCmp) prevPos = maxPosValueOfEndCmp;

                        if(rightPos - prevPos >= (width + 2 * componentDistance)) {
                            positionX = prevPos + (rightPos - prevPos) / 2;
                            isAdd = true;
                        }
                    } else {
                        if(rightPos - leftPos >= (width + 2 * componentDistance)) {
                            positionX = leftPos + (rightPos - leftPos) / 2;
                            isAdd = true;
                        }
                    }
                }
            }
        }
        // console.log('giorgi- addValidation _ isAdd:___second -> ', isAdd);
        
        /********** calculate position x **********/
        if (!isAdd && (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout")) {
            let currentDoorsArr = const_var.newDoorsArray;
            if (checkType === 'update_check') currentDoorsArr = checkableDoorArr;
            
            if (topPos - bottomPos >= height) {
                let isUpdate = true;
                const calculateArray = currentDoorsArr.filter((item) => 
                        targetWallNameArr.includes(item.userData.wallName) && 
                        item.positionY - item.height / 2 < height + componentDistance
                    ).sort((a, b) => a.positionX - b.positionX)
                let distance = 0;
                for(let i = 0; i < calculateArray.length; i++) {
                    distance = distance + calculateArray[i].width 
                }
    
                if (rightPos - leftPos >= distance + width + (calculateArray.length + 2) * componentDistance) {
                    for(let i = 0; i < calculateArray.length; i++) {
                        if ((calculateArray[i].userData.compType !== "garage_door" && calculateArray[i].userData.compType !== "garage_door_frameout" && calculateArray[i].userData.compType !== "walkin" && calculateArray[i].userData.compType !== "walkin_frameout") && calculateArray[i].positionY + calculateArray[i].height / 2 > height) {
                            isUpdate = false;
                            break;
                        }
                    }
                } else {
                    isUpdate = false;
                }
                // console.log('giorgi- addValidation _ isUpdate -> ', isUpdate);
    
                if (isUpdate) {
                    let updatePosCheck = true;
                    let lastDistance = 0;
                    for(let i = 0; i < calculateArray.length; i++) {
                        const index = newArray.findIndex(item => item.uniqueId === calculateArray[i].uniqueId);
                        if (index !== -1) {
                            const newPosX = leftPos + lastDistance + componentDistance + calculateArray[i].width / 2;
                            const overlapVerticalCmp = const_var.newDoorsArray.find(s => (
                                targetWallNameArr.includes(s.userData.wallName) && 
                                (s.userData.compType === 'window' || s.userData.compType === "window_frameout") &&
                                s.positionX - s.width / 2 < newPosX + calculateArray[i].width / 2 + componentDistance && 
                                s.positionX + s.width / 2 > newPosX - calculateArray[i].width / 2 - componentDistance &&
                                s.positionY - s.height / 2 < calculateArray[i].height + componentDistance && 
                                s.positionY + s.height / 2 > calculateArray[i].height - componentDistance  
                            ))
                            if (overlapVerticalCmp) {
                                updatePosCheck = false;
                                break;
                            }

                            const updatedPos = leftPos + lastDistance + componentDistance + calculateArray[i].width / 2;

                            if(newArray[index].minLimitX > updatedPos || updatedPos > newArray[index].maxLimitX) {
                                updatePosCheck = false;
                                break;
                            }
                            newArray[index].positionX = updatedPos;
                            
                            lastDistance = lastDistance + componentDistance + calculateArray[i].width;
                        }
                    }
    
                    if (updatePosCheck) {
                        isAdd = true;
                        positionX = leftPos + lastDistance + componentDistance + width / 2
                    } else {
                        const_var.newDoorsArray = newArray;
                    }
                }

                // console.log('giorgi- addValidation _ isAdd:___last -> ', isAdd);
            }
        }
        
        if (isAdd || compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
            minLimitX = (leftPos + width / 2 + const_var.componentDistance);
            maxLimitX = (rightPos - width / 2 - const_var.componentDistance);            
            break;
        }
    }

    if (compType == "window" || compType == "window_frameout") {
        if (positionX < minLimitX || positionX > maxLimitX) {
            isAdd = false;
        }
    }
    /********** calculate position x, y **********/
    
    revertPosOfCmp(doorsArray, wallName)

    return {
        isAdd, positionX, positionY, minLimitX, maxLimitX, newArray
    }
}

export const editValidation = ({ compType, compName, width, height, wallName, parentkey, childkey, nestedkey, positionX, positionY, sideArray }) => {
    // console.log('giorgi- edit validation -> ', { compType, compName, width, height, wallName, parentkey, childkey, nestedkey, positionX, positionY, sideArray });
    const componentDistance = const_var.componentDistance;

    let isEdit = false;
    let isChangePos = false;

    const alpha = Math.atan(params.p_r_p / 12);
    const frontLeanAlpha = Math.atan(params.b_l_t_r_pF / 12);
    const backLeanAlpha = Math.atan(params.b_l_t_r_pB / 12);
    const leftLeanAlpha = Math.atan(params.b_l_t_r_p / 12);
    const rightLeanAlpha = Math.atan(params.b_l_t_r_pR / 12);
    const trimHeight = 0;
    let regularHeight = 0;
    let trimThickness = 0.2;

    if (params.p_r_s === 1) {
        trimThickness = 0.2;
        regularHeight = 0.4;
    } else if (params.p_r_s === 2) {
        trimThickness = 0.2;
        regularHeight = 0;
    } else if (params.p_r_s === 3) {
        trimThickness = 0.05;
        regularHeight = 0;
    }

    let trimOffsetHeight = (params.p_r_p / 12) * trimThickness;
    trimOffsetHeight = 0 

    /********** y - limit **********/
    let topPos = 0;
    let bottomPos = 0;

    if (params.singleSlope) {
        if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                topPos = params.p_h - trimHeight - Math.tan(alpha) * (width + componentDistance * 2)
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_l_s_w') {
                topPos = params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight - trimOffsetHeight
            } else if (wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w') {
                topPos = params.p_h - trimHeight - trimOffsetHeight
            } else if (wallName === 'c_b_l_s_r_w') {
                topPos = params.p_h - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075) * params.p_r_p / 12
            } else if (wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w') {
                topPos = params.p_h - trimHeight - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075) * params.p_r_p / 12 - Math.tan(alpha) * (width + componentDistance * 2)
            } else if (wallName === 'c_b_r_s_l_w') {
                topPos = params.p_h - (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12
            } else if (wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
                topPos = params.p_h - trimHeight - Math.tan(alpha) * (width + componentDistance * 2)
            }
            else if (wallName === 'R_L_F_W' || wallName === 'R_L_B_W' || wallName === 'R_L_F_S_W') {
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - Math.tan(rightLeanAlpha) * (width + componentDistance * 2)
            } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
                topPos = params.leanR_p_h - trimHeight - trimOffsetHeight
            }
            else if (wallName === 'R_L_L_S_W') {
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w
            }

        } else {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                bottomPos = componentDistance;
                topPos = params.p_h - trimHeight - Math.tan(alpha) * (width + componentDistance * 2);
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_l_s_w') {
                bottomPos = componentDistance;
                topPos = params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight - trimOffsetHeight - componentDistance;
            } else if (wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w') {
                bottomPos = componentDistance;
                topPos = params.p_h - trimHeight - trimOffsetHeight - componentDistance;
            } else if (wallName === 'c_b_l_s_r_w') {
                bottomPos = componentDistance;
                topPos = params.p_h - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075) * params.p_r_p / 12 - componentDistance;
            } else if (wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w') {
                bottomPos = componentDistance;
                topPos = params.p_h - trimHeight - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075) * params.p_r_p / 12 - Math.tan(alpha) * (width + componentDistance * 2);
            } else if (wallName === 'c_b_r_s_l_w') {
                bottomPos = componentDistance;
                topPos = params.p_h - (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 - componentDistance;
            } else if (wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
                bottomPos = componentDistance;
                topPos = params.p_h - trimHeight - Math.tan(alpha) * (width + componentDistance * 2);
            }
            else if (wallName === 'R_L_F_W' || wallName === 'R_L_B_W' || wallName === 'R_L_F_S_W') {
                bottomPos = componentDistance
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - Math.tan(rightLeanAlpha) * (width + componentDistance * 2)
            } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
                bottomPos = componentDistance
                topPos = params.leanR_p_h - trimHeight - trimOffsetHeight - componentDistance
            }else if (wallName === 'R_L_L_S_W') {
                bottomPos = componentDistance
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w - componentDistance
            }
        }
    } else {
        if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                topPos = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance)
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w' || wallName === 'c_b_l_s_w') {
                topPos = params.p_h - trimHeight - trimOffsetHeight
            } else if (wallName === 'F_L_R_W' || wallName === 'F_L_L_W' || wallName === 'F_L_R_S_W') {
                topPos = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight - Math.tan(frontLeanAlpha) * (width + componentDistance * 2)
            } else if (wallName === 'F_L_F_W' || wallName === 'F_L_F_S_W') {
                topPos = params.leanF_p_h - trimHeight - trimOffsetHeight
            } else if (wallName === 'B_L_F_W' || wallName === 'B_L_B_W' || wallName === 'B_L_L_S_W') {
                topPos = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight - Math.tan(backLeanAlpha) * (width + componentDistance * 2)
            } else if (wallName === 'B_L_S_W' || wallName === 'B_L_F_S_W') {
                topPos = params.leanB_p_h - trimHeight - trimOffsetHeight
            } else if (wallName === 'R_L_F_W' || wallName === 'R_L_B_W' || wallName === 'R_L_F_S_W') {
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - Math.tan(rightLeanAlpha) * (width + componentDistance * 2)
            } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
                topPos = params.leanR_p_h - trimHeight - trimOffsetHeight
            } else if (wallName === 'L_L_F_W' || wallName === 'L_L_B_W' || wallName === 'L_L_F_S_W') {
                topPos = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight - Math.tan(leftLeanAlpha) * (width + componentDistance * 2)
            } else if (wallName === 'L_L_L_W' || wallName === 'L_L_L_S_W') {
                topPos = params.lean_p_h - trimHeight - trimOffsetHeight
            } else if (wallName === 'c_b_l_s_r_w') {
                let overHeight = 0;
                if (parseInt(params.cB_addStorage_left) < params.p_w / 2) {
                    if (params.p_r_s === 1) {
                        overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                    }
                } else {
                    if (params.p_r_s === 1) {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                    }
                }
                
                topPos = params.p_h + overHeight
            } else if (wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w') {
                if (parseInt(params.cB_addStorage_left) - params.p_w / 2 < width / 2 + componentDistance) {
                    topPos = params.p_h + (params.p_r_p / 12) * parseInt(params.cB_addStorage_left) + regularHeight - trimHeight - Math.tan(alpha) * (width + componentDistance * 2)
                } else {
                    topPos = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance)
                }
            } else if (wallName === 'c_b_r_s_l_w') {
                let overHeight = 0;
                if (parseInt(params.cB_addStorage_right) < params.p_w / 2) {
                    if (params.p_r_s === 1) {
                        overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                    }
                } else {
                    if (params.p_r_s === 1) {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                    }
                }
    
                topPos = params.p_h + overHeight
            } else if (wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
                if (parseInt(params.cB_addStorage_right) - params.p_w / 2 < width / 2 + componentDistance) {
                    topPos = params.p_h + (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) + regularHeight - trimHeight - Math.tan(alpha) * (width + componentDistance * 2)
                } else {
                    topPos = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance)
                }
            } else if (wallName === 'R_L_L_S_W') {
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w
            } else if (wallName === 'L_L_R_S_W') {
                topPos = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w
            }
        } else {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                bottomPos = componentDistance
                topPos = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance)
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w' || wallName === 'c_b_l_s_w') {
                bottomPos = componentDistance
                topPos = params.p_h - trimHeight - trimOffsetHeight - componentDistance
            } else if (wallName === 'F_L_R_W' || wallName === 'F_L_L_W' || wallName === 'F_L_R_S_W') {
                bottomPos = componentDistance
                topPos = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight - Math.tan(frontLeanAlpha) * (width + componentDistance * 2)
            } else if (wallName === 'F_L_F_W' || wallName === 'F_L_F_S_W') {
                bottomPos = componentDistance
                topPos = params.leanF_p_h - trimHeight - trimOffsetHeight - componentDistance
            } else if (wallName === 'B_L_F_W' || wallName === 'B_L_B_W' || wallName === 'B_L_L_S_W') {
                bottomPos = componentDistance
                topPos = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight - Math.tan(backLeanAlpha) * (width + componentDistance * 2)
            } else if (wallName === 'B_L_S_W' || wallName === 'B_L_F_S_W') {
                bottomPos = componentDistance
                topPos = params.leanB_p_h - trimHeight - trimOffsetHeight - componentDistance
            } else if (wallName === 'R_L_F_W' || wallName === 'R_L_B_W' || wallName === 'R_L_F_S_W') {
                bottomPos = componentDistance
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - Math.tan(rightLeanAlpha) * (width + componentDistance * 2)
            } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
                bottomPos = componentDistance
                topPos = params.leanR_p_h - trimHeight - trimOffsetHeight - componentDistance
            } else if (wallName === 'L_L_F_W' || wallName === 'L_L_B_W' || wallName === 'L_L_F_S_W') {
                bottomPos = componentDistance
                topPos = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight - Math.tan(leftLeanAlpha) * (width + componentDistance * 2)
            } else if (wallName === 'L_L_L_W' || wallName === 'L_L_L_S_W') {
                bottomPos = componentDistance
                topPos = params.lean_p_h - trimHeight - trimOffsetHeight - componentDistance
            } else if (wallName === 'c_b_l_s_r_w') {
                let overHeight = 0;
                if (parseInt(params.cB_addStorage_left) < params.p_w / 2) {
                    if (params.p_r_s === 1) {
                        overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                    }
                } else {
                    if (params.p_r_s === 1) {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                    }
                }
    
                bottomPos = componentDistance
                topPos = params.p_h + overHeight - componentDistance
            } else if (wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w') {
                if (parseInt(params.cB_addStorage_left) - params.p_w / 2 < width / 2 + componentDistance) {
                    bottomPos = componentDistance
                    topPos = params.p_h + (params.p_r_p / 12) * parseInt(params.cB_addStorage_left) + regularHeight - trimHeight - Math.tan(alpha) * (width + componentDistance * 2)
                } else {
                    bottomPos = componentDistance
                    topPos = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance)
                }
            } else if (wallName === 'c_b_r_s_l_w') {
                let overHeight = 0;
                if (parseInt(params.cB_addStorage_right) < params.p_w / 2) {
                    if (params.p_r_s === 1) {
                        overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                    }
                } else {
                    if (params.p_r_s === 1) {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + 0.4;
                    } else {
                        overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                    }
                }
    
                bottomPos = componentDistance
                topPos = params.p_h + overHeight - componentDistance
            } else if (wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
                if (parseInt(params.cB_addStorage_right) - params.p_w / 2 < width / 2 + componentDistance) {
                    bottomPos = componentDistance
                    topPos = params.p_h + (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) + regularHeight - trimHeight - Math.tan(alpha) * (width + componentDistance * 2)
                } else {
                    bottomPos = componentDistance
                    topPos = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance)
                }
            } else if (wallName === 'R_L_L_S_W') {
                bottomPos = componentDistance
                topPos = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w - componentDistance
            } else if (wallName === 'L_L_R_S_W') {
                bottomPos = componentDistance
                topPos = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w - componentDistance
            }
        }
    }
    /********** y - limit **********/
    
    const clearance = const_var.newComponentArray[parentkey][childkey][nestedkey]['Size'][`${width}x${height}`];
    const isEndSide = const_var.entry_wall_location[wallName];

    if (clearance && (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout")) {
        if (isEndSide.includes('end') && clearance.end_clearance) {
            topPos -= clearance.end_clearance;
        } else if (clearance.side_clearance) {
            topPos -= clearance.side_clearance;
        }
    }

    /********** x - limit **********/
    let leftPos = 0;
    let rightPos = 0;

    if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
        positionY = height / 2;
    }

    if (params.singleSlope) {
        if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w') {
                const maxHeight = params.p_h - trimHeight;
                if (height <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    leftPos = -(params.p_w / 2)
                    rightPos = params.p_w / 2
                } else {
                    const minValue = -params.p_w / 2 + (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = params.p_w / 2
                }
            } else if (wallName === 'c_b_b_w') {
                const maxHeight = params.p_h - trimHeight;
                if (height <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    leftPos = -(params.p_w / 2)
                    rightPos = params.p_w / 2
                } else {
                    const minValue = params.p_w / 2 - (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -params.p_w / 2
                    rightPos = -minValue
                }
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_l_w') {
                leftPos = -(params.p_d / 2)
                rightPos = params.p_d / 2
            } else if (wallName === 'c_b_r_s_w') {
                leftPos = -(parseInt(params.p_u_t) - params.p_d / 2)
                rightPos = params.p_d / 2
            } else if (wallName === 'c_b_l_s_w') {
                leftPos = -(params.p_d / 2)
                rightPos = parseInt(params.p_u_t) - params.p_d / 2
            } else if (wallName === 'c_b_l_s_f_w') {
                const maxHeight = params.p_h - trimHeight;
                if (height <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    leftPos = -(params.p_w / 2)
                    rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                } else {
                    const minValue = -params.p_w / 2 + (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                }
            } else if (wallName === 'c_b_l_s_b_w') {
                const maxHeight = params.p_h - trimHeight;
                if (height <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                    rightPos = params.p_w / 2
                } else {
                    const minValue = params.p_w / 2 - (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                    rightPos = -minValue
                }
            } else if (wallName === 'c_b_r_s_f_w') {
                const maxHeight = params.p_h - trimHeight;
                if (height <= params.p_h - (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) - trimHeight) {
                    leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_right)
                    rightPos = params.p_w / 2
                } else {
                    const minValue = -params.p_w / 2 + (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = params.p_w / 2
                }
            } else if (wallName === 'c_b_r_s_b_w') {
                const maxHeight = params.p_h - trimHeight;
                if (height <= params.p_h - (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) - trimHeight) {
                    leftPos = -(params.p_w / 2)
                    rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_right)
                } else {
                    const minValue = params.p_w / 2 - (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -params.p_w / 2
                    rightPos = -minValue
                }
            }
            else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (height <= params.leanR_p_h + regularHeight - trimHeight) {
                    leftPos = params.p_w / 2
                    rightPos = params.p_w / 2 + params.leanR_p_w
                } else {
                    const minValue = (maxHeight - height) / Math.tan(rightLeanAlpha);
                    leftPos = params.p_w / 2
                    rightPos = params.p_w / 2 + minValue
                }
            } else if (wallName === 'R_L_B_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (height <= params.leanR_p_h + regularHeight - trimHeight) {
                    leftPos = -params.p_w / 2 - params.leanR_p_w
                    rightPos = -params.p_w / 2
                } else {
                    const minValue = (maxHeight - height) / Math.tan(rightLeanAlpha);
                    leftPos = -params.p_w / 2 - minValue
                    rightPos = -params.p_w / 2
                }
            }
        } else {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w') {
                const maxHeight = params.p_h - trimHeight;
                if (positionY + height / 2 <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    leftPos = -(params.p_w / 2)
                    rightPos = params.p_w / 2
                } else {
                    const minValue = -params.p_w / 2 + (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = params.p_w / 2
                }
            } else if (wallName === 'c_b_b_w') {
                const maxHeight = params.p_h - trimHeight;
                if (positionY + height / 2 <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    leftPos = -(params.p_w / 2)
                    rightPos = params.p_w / 2
                } else {
                    const minValue = params.p_w / 2 - (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -params.p_w / 2
                    rightPos = -minValue
                }
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_l_w') {
                leftPos = -(params.p_d / 2)
                rightPos = params.p_d / 2
            } else if (wallName === 'c_b_r_s_w') {
                leftPos = -(parseInt(params.p_u_t) - params.p_d / 2)
                rightPos = params.p_d / 2
            } else if (wallName === 'c_b_l_s_w') {
                leftPos = -(params.p_d / 2)
                rightPos = parseInt(params.p_u_t) - params.p_d / 2
            } else if (wallName === 'c_b_l_s_f_w') {
                const maxHeight = params.p_h - trimHeight;
                if (positionY + height / 2 <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    leftPos = -(params.p_w / 2)
                    rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                } else {
                    const minValue = -params.p_w / 2 + (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                }
            } else if (wallName === 'c_b_l_s_b_w') {
                const maxHeight = params.p_h - trimHeight;
                if (positionY + height / 2 <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                    rightPos = params.p_w / 2
                } else {
                    const minValue = params.p_w / 2 - (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                    rightPos = -minValue
                }
            } else if (wallName === 'c_b_r_s_f_w') {
                const maxHeight = params.p_h - trimHeight;
                if (positionY + height / 2 <= params.p_h - (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) - trimHeight) {
                    leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_right)
                    rightPos = params.p_w / 2
                } else {
                    const minValue = -params.p_w / 2 + (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = params.p_w / 2
                }
            } else if (wallName === 'c_b_r_s_b_w') {
                const maxHeight = params.p_h - trimHeight;
                if (positionY + height / 2 <= params.p_h - (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) - trimHeight) {
                    leftPos = -(params.p_w / 2)
                    rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_right)
                } else {
                    const minValue = params.p_w / 2 - (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -params.p_w / 2
                    rightPos = -minValue
                }
            }
            else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (positionY + height / 2 <= params.leanR_p_h + regularHeight - trimHeight) {
                    leftPos = params.p_w / 2
                    rightPos = params.p_w / 2 + params.leanR_p_w
                } else {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(rightLeanAlpha);
                    leftPos = params.p_w / 2
                    rightPos = params.p_w / 2 + minValue
                }
            } else if (wallName === 'R_L_B_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (positionY + height / 2 <= params.leanR_p_h + regularHeight - trimHeight) {
                    leftPos = -params.p_w / 2 - params.leanR_p_w
                    rightPos = -params.p_w / 2
                } else {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(rightLeanAlpha);
                    leftPos = -params.p_w / 2 - minValue
                    rightPos = -params.p_w / 2
                }
            }
        }
    } else {
        if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
            if(wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight ;
                if (height <= params.p_h + regularHeight - trimHeight) {
                    leftPos = -(params.p_w / 2)
                    rightPos = params.p_w / 2
                } else {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = minValue
                }
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_l_w') {
                leftPos = -params.p_d / 2
                rightPos = params.p_d / 2
            } else if (wallName === 'F_L_R_W' || wallName === 'F_L_R_S_W') {
                const maxHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight;
                if (height <= params.leanF_p_h + regularHeight - trimHeight) {
                    leftPos = -params.p_d / 2 - 0.15 - params.leanF_p_w
                    rightPos = -params.p_d / 2 - 0.15
                } else {
                    const minValue = (maxHeight - height) / Math.tan(frontLeanAlpha);
                    leftPos = -params.p_d / 2 - 0.15 - minValue
                    rightPos = -params.p_d / 2 - 0.15
                }
            } else if (wallName === 'F_L_L_W') {
                const maxHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight;
                if (height <= params.leanF_p_h + regularHeight - trimHeight) {
                    leftPos = params.p_d / 2 + 0.15
                    rightPos = params.p_d / 2 + 0.15+ params.leanF_p_w
                } else {
                    const minValue = (maxHeight - height) / Math.tan(frontLeanAlpha);
                    leftPos = params.p_d / 2 + 0.15
                    rightPos = params.p_d / 2 + 0.15 + minValue
                }
            } else if (wallName === 'F_L_F_W') {
                leftPos = params.add_left_front_lean_porch ? params.leanF_p_pos - params.leanF_p_d / 2 - params.lean_p_w : params.leanF_p_pos - params.leanF_p_d / 2
                rightPos = params.add_right_front_lean_porch ? params.leanF_p_pos + params.leanF_p_d / 2 + params.leanR_p_w : params.leanF_p_pos + params.leanF_p_d / 2
            } else if (wallName === 'B_L_F_W' || wallName === 'B_L_L_S_W') {
                const maxHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight;
                if (height <= params.leanB_p_h + regularHeight - trimHeight) {
                    leftPos = params.p_d / 2 + 0.15
                    rightPos = params.p_d / 2 + 0.15 + params.leanB_p_w
                } else {
                    const minValue = (maxHeight - height) / Math.tan(backLeanAlpha);
                    leftPos = params.p_d / 2 + 0.15
                    rightPos = params.p_d / 2 + 0.15 + minValue
                }
            } else if (wallName === 'B_L_B_W') {
                const maxHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight;
                if (height <= params.leanB_p_h + regularHeight - trimHeight) {
                    leftPos = -params.p_d / 2 - 0.15 - params.leanB_p_w
                    rightPos = -params.p_d / 2 - 0.15
                } else {
                    const minValue = (maxHeight - height) / Math.tan(backLeanAlpha);
                    leftPos = -params.p_d / 2 - 0.15 - minValue
                    rightPos = -params.p_d / 2 - 0.15
                }
            } else if (wallName === 'B_L_S_W') {
                leftPos = params.add_right_back_lean_porch ? -params.leanB_p_pos - params.leanB_p_d / 2 - params.leanR_p_w : -params.leanB_p_pos - params.leanB_p_d / 2
                rightPos = params.add_left_back_lean_porch ? -params.leanB_p_pos + params.leanB_p_d / 2 + params.lean_p_w : -params.leanB_p_pos + params.leanB_p_d / 2
            } else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (height <= params.leanR_p_h + regularHeight - trimHeight) {
                    leftPos = params.p_w / 2
                    rightPos = params.p_w / 2 + params.leanR_p_w
                } else {
                    const minValue = (maxHeight - height) / Math.tan(rightLeanAlpha);
                    leftPos = params.p_w / 2
                    rightPos = params.p_w / 2 + minValue
                }
            } else if (wallName === 'R_L_B_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (height <= params.leanR_p_h + regularHeight - trimHeight) {
                    leftPos = -params.p_w / 2 - params.leanR_p_w
                    rightPos = -params.p_w / 2
                } else {
                    const minValue = (maxHeight - height) / Math.tan(rightLeanAlpha);
                    leftPos = -params.p_w / 2 - minValue
                    rightPos = -params.p_w / 2
                }
            } else if (wallName === 'R_L_R_W') {
                leftPos = -params.add_right_front_lean_porch ? params.leanR_p_pos - params.leanR_p_d / 2 - params.leanF_p_w : -params.leanR_p_pos - params.leanR_p_d / 2
                rightPos = -params.add_right_back_lean_porch ? params.leanR_p_pos + params.leanR_p_d / 2 + params.leanB_p_w : -params.leanR_p_pos + params.leanR_p_d / 2
            } else if (wallName === 'L_L_F_W' || wallName === 'L_L_F_S_W') {
                const maxHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight;
                if (height <= params.lean_p_h + regularHeight - trimHeight) {
                    leftPos = -params.p_w / 2 - params.lean_p_w
                    rightPos = -params.p_w / 2
                } else {
                    const minValue = (maxHeight - height) / Math.tan(leftLeanAlpha);
                    leftPos = -params.p_w / 2 - minValue
                    rightPos = -params.p_w / 2
                }
            } else if (wallName === 'L_L_B_W') {
                const maxHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight;
                if (height <= params.lean_p_h + regularHeight - trimHeight) {
                    leftPos = params.p_w / 2
                    rightPos = params.p_w / 2 + params.lean_p_w
                } else {
                    const minValue = (maxHeight - height) / Math.tan(leftLeanAlpha);
                    leftPos = params.p_w / 2
                    rightPos = params.p_w / 2 + minValue
                }
            } else if (wallName === 'L_L_L_W') {
                leftPos = params.add_left_back_lean_porch ? params.lean_p_pos - params.lean_p_d / 2 - params.leanB_p_w : params.lean_p_pos - params.lean_p_d / 2
                rightPos = params.add_left_front_lean_porch ? params.lean_p_pos + params.lean_p_d / 2 + params.leanF_p_w : params.lean_p_pos + params.lean_p_d / 2
            } else if (wallName === 'c_b_r_s_w') {
                leftPos = -(parseInt(params.p_u_t) - params.p_d / 2)
                rightPos = params.p_d / 2
            } else if (wallName === 'c_b_l_s_w') {
                leftPos = -params.p_d / 2
                rightPos = parseInt(params.p_u_t) - params.p_d / 2
            } else if (wallName === 'c_b_l_s_f_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight ;
                if (height <= params.p_h + regularHeight - trimHeight) {
                    leftPos = -params.p_w / 2
                    rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                } else if (height <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_left) - params.p_w / 2)) {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                } else {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = minValue
                }
            } else if (wallName === 'c_b_l_s_b_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight ;
                if (height <= params.p_h + regularHeight - trimHeight) {
                    leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                    rightPos = params.p_w / 2
                } else if (height <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_left) - params.p_w / 2)) {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                    rightPos = minValue
                } else {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = minValue
                }
            } else if (wallName === 'c_b_r_s_f_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight ;
                if (height <= params.p_h + regularHeight - trimHeight) {
                    leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_right)
                    rightPos = params.p_w / 2
                } else if (height <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_right) - params.p_w / 2)) {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_right)
                    rightPos = minValue
                } else {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = minValue
                }
            } else if (wallName === 'c_b_r_s_b_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight ;
                if (height <= params.p_h + regularHeight - trimHeight) {
                    leftPos = -params.p_w / 2
                    rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_right)
                } else if (height <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_right) - params.p_w / 2)) {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_right)
                } else {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = minValue
                }
            } else if (wallName === 'F_L_F_S_W') {
                leftPos = params.leanF_p_pos - params.leanF_p_d / 2
                rightPos = params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front)
            } else if (wallName === 'B_L_F_S_W') {
                leftPos = -params.leanB_p_pos + params.leanB_p_d / 2 - parseInt(params.add_storage_back)
                rightPos = -params.leanB_p_pos + params.leanB_p_d / 2
            } else if (wallName === 'R_L_R_S_W') {
                leftPos = -params.leanR_p_pos + params.leanR_p_d / 2 - parseInt(params.add_storage_right)
                rightPos = -params.leanR_p_pos + params.leanR_p_d / 2
            } else if (wallName === 'R_L_L_S_W') {
                leftPos = params.leanR_p_pos - params.leanR_p_d / 2
                rightPos = params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right)
            } else if (wallName === 'L_L_L_S_W') {
                leftPos = params.lean_p_pos - params.lean_p_d / 2
                rightPos = params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage)
            } else if (wallName === 'L_L_R_S_W') {
                leftPos = -params.lean_p_pos + params.lean_p_d / 2 - parseInt(params.add_storage)
                rightPos = -params.lean_p_pos + params.lean_p_d / 2
            }
        } else {
            if(wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight;
                if (positionY + height / 2 <= params.p_h + regularHeight - trimHeight) {
                    leftPos = -(params.p_w / 2)
                    rightPos = params.p_w / 2
                } else {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = minValue
                }
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_l_w') {
                leftPos = -params.p_d / 2
                rightPos = params.p_d / 2
            } else if (wallName === 'F_L_R_W' || wallName === 'F_L_R_S_W') {
                const maxHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight;
                if (positionY + height / 2 <= params.leanF_p_h + regularHeight - trimHeight) {
                    leftPos = -params.p_d / 2 - 0.15 - params.leanF_p_w
                    rightPos = -params.p_d / 2 - 0.15
                } else {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(frontLeanAlpha);
                    leftPos = -params.p_d / 2 - 0.15 - minValue
                    rightPos = -params.p_d / 2 - 0.15
                }
            } else if (wallName === 'F_L_L_W') {
                const maxHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight;
                if (positionY + height / 2 <= params.leanF_p_h + regularHeight - trimHeight) {
                    leftPos = params.p_d / 2 + 0.15
                    rightPos = params.p_d / 2 + 0.15 + params.leanF_p_w
                } else {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(frontLeanAlpha);
                    leftPos = params.p_d / 2 + 0.15
                    rightPos = params.p_d / 2 + 0.15 + minValue
                }
            } else if (wallName === 'F_L_F_W') {
                leftPos = params.add_left_front_lean_porch ? params.leanF_p_pos - params.leanF_p_d / 2 - params.lean_p_w : params.leanF_p_pos - params.leanF_p_d / 2
                rightPos = params.add_right_front_lean_porch ? params.leanF_p_pos + params.leanF_p_d / 2 + params.leanR_p_w : params.leanF_p_pos + params.leanF_p_d / 2
            } else if (wallName === 'B_L_F_W' || wallName === 'B_L_L_S_W') {
                const maxHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight;
                if (positionY + height / 2 <= params.leanB_p_h + regularHeight - trimHeight) {
                    leftPos = params.p_d / 2 + 0.15
                    rightPos = params.p_d / 2 + 0.15 + params.leanB_p_w
                } else {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(backLeanAlpha);
                    leftPos = params.p_d / 2 + 0.15
                    rightPos = params.p_d / 2 + 0.15 + minValue
                }
            } else if (wallName === 'B_L_B_W') {
                const maxHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight;
                if (positionY + height / 2 <= params.leanB_p_h + regularHeight - trimHeight) {
                    leftPos = -params.p_d / 2 - 0.15 - params.leanB_p_w
                    rightPos = -params.p_d / 2 - 0.15
                } else {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(backLeanAlpha);
                    leftPos = -params.p_d / 2 - 0.15 - minValue
                    rightPos = -params.p_d / 2 - 0.15
                }
            } else if (wallName === 'B_L_S_W') {
                leftPos = params.add_right_back_lean_porch ? -params.leanB_p_pos - params.leanB_p_d / 2 - params.leanR_p_w : -params.leanB_p_pos - params.leanB_p_d / 2
                rightPos = params.add_left_back_lean_porch ? -params.leanB_p_pos + params.leanB_p_d / 2 + params.lean_p_w : -params.leanB_p_pos + params.leanB_p_d / 2
            } else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (positionY + height / 2 <= params.leanR_p_h + regularHeight - trimHeight) {
                    leftPos = params.p_w / 2
                    rightPos = params.p_w / 2 + params.leanR_p_w
                } else {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(rightLeanAlpha);
                    leftPos = params.p_w / 2
                    rightPos = params.p_w / 2 + minValue
                }
            } else if (wallName === 'R_L_B_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (positionY + height / 2 <= params.leanR_p_h + regularHeight - trimHeight) {
                    leftPos = -params.p_w / 2 - params.leanR_p_w
                    rightPos = -params.p_w / 2
                } else {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(rightLeanAlpha);
                    leftPos = -params.p_w / 2 - minValue
                    rightPos = -params.p_w / 2
                }
            } else if (wallName === 'R_L_R_W') {
                leftPos = -params.add_right_front_lean_porch ? params.leanR_p_pos - params.leanR_p_d / 2 - params.leanF_p_w : -params.leanR_p_pos - params.leanR_p_d / 2
                rightPos = -params.add_right_back_lean_porch ? params.leanR_p_pos + params.leanR_p_d / 2 + params.leanB_p_w : -params.leanR_p_pos + params.leanR_p_d / 2
            } else if (wallName === 'L_L_F_W' || wallName === 'L_L_F_S_W') {
                const maxHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight;
                if (positionY + height / 2 <= params.lean_p_h + regularHeight - trimHeight) {
                    leftPos = -params.p_w / 2 - params.lean_p_w
                    rightPos = -params.p_w / 2
                } else {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(leftLeanAlpha);
                    leftPos = -params.p_w / 2 - minValue
                    rightPos = -params.p_w / 2
                }
            } else if (wallName === 'L_L_B_W') {
                const maxHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight;
                if (positionY + height / 2 <= params.lean_p_h + regularHeight - trimHeight) {
                    leftPos = params.p_w / 2
                    rightPos = params.p_w / 2 + params.lean_p_w
                } else {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(leftLeanAlpha);
                    leftPos = params.p_w / 2
                    rightPos = params.p_w / 2 + minValue
                }
            } else if (wallName === 'L_L_L_W') {
                leftPos = params.add_left_back_lean_porch ? params.lean_p_pos - params.lean_p_d / 2 - params.leanB_p_w : params.lean_p_pos - params.lean_p_d / 2
                rightPos = params.add_left_front_lean_porch ? params.lean_p_pos + params.lean_p_d / 2 + params.leanF_p_w : params.lean_p_pos + params.lean_p_d / 2
            } else if (wallName === 'c_b_r_s_w') {
                leftPos = -(parseInt(params.p_u_t) - params.p_d / 2)
                rightPos = params.p_d / 2
            } else if (wallName === 'c_b_l_s_w') {
                leftPos = -params.p_d / 2
                rightPos = parseInt(params.p_u_t) - params.p_d / 2
            } else if (wallName === 'c_b_l_s_f_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight;
                if (positionY + height / 2 <= params.p_h + regularHeight - trimHeight) {
                    leftPos = -params.p_w / 2
                    rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                } else if (positionY + height / 2 <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_left) - params.p_w / 2)) {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                } else {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = minValue
                }
            } else if (wallName === 'c_b_l_s_b_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight;
                if (positionY + height / 2 <= params.p_h + regularHeight - trimHeight) {
                    leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                    rightPos = params.p_w / 2
                } else if (positionY + height / 2 <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_left) - params.p_w / 2)) {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_left)
                    rightPos = minValue
                } else {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = minValue
                }
            } else if (wallName === 'c_b_r_s_f_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight;
                if (positionY + height / 2 <= params.p_h + regularHeight - trimHeight) {
                    leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_right)
                    rightPos = params.p_w / 2
                } else if (positionY + height / 2 <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_right) - params.p_w / 2)) {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = params.p_w / 2 - parseInt(params.cB_addStorage_right)
                    rightPos = minValue
                } else {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = minValue
                }
            } else if (wallName === 'c_b_r_s_b_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight;
                if (positionY + height / 2 <= params.p_h + regularHeight - trimHeight) {
                    leftPos = -params.p_w / 2
                    rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_right)
                } else if (positionY + height / 2 <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_right) - params.p_w / 2)) {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = -params.p_w / 2 + parseInt(params.cB_addStorage_right)
                } else {
                    const minValue = (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    leftPos = -minValue
                    rightPos = minValue
                }
            } else if (wallName === 'F_L_F_S_W') {
                leftPos = params.leanF_p_pos - params.leanF_p_d / 2
                rightPos = params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front)
            } else if (wallName === 'B_L_F_S_W') {
                leftPos = -params.leanB_p_pos + params.leanB_p_d / 2 - parseInt(params.add_storage_back)
                rightPos = -params.leanB_p_pos + params.leanB_p_d / 2
            } else if (wallName === 'R_L_R_S_W') {
                leftPos = -params.leanR_p_pos + params.leanR_p_d / 2 - parseInt(params.add_storage_right)
                rightPos = -params.leanR_p_pos + params.leanR_p_d / 2
            } else if (wallName === 'R_L_L_S_W') {
                leftPos = params.leanR_p_pos - params.leanR_p_d / 2
                rightPos = params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right)
            } else if (wallName === 'L_L_L_S_W') {
                leftPos = params.lean_p_pos - params.lean_p_d / 2
                rightPos = params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage)
            } else if (wallName === 'L_L_R_S_W') {
                leftPos = -params.lean_p_pos + params.lean_p_d / 2 - parseInt(params.add_storage)
                rightPos = -params.lean_p_pos + params.lean_p_d / 2
            }
        }
    }
    /********** x - limit **********/
    const doorsArray = [...sideArray];
    revertPosOfCmp(doorsArray, wallName)

    const validationArray = doorsArray.filter((item) => 
        (item.positionX + item.width / 2 > positionX - width / 2 - componentDistance && 
            item.positionX - item.width / 2 < positionX + width / 2 + componentDistance) && 
        (item.positionY - item.height / 2 < positionY + height / 2 + componentDistance && 
            item.positionY + item.height / 2 > positionY - height / 2 - componentDistance
        )
    );

    if (validationArray.length === 0) {
        if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
            if ((positionX - width / 2 - componentDistance >= leftPos && positionX + width / 2 + componentDistance <= rightPos) && (height <= topPos)) {
                isEdit = true;
            }
        } else {
            if ((positionX - width / 2 - componentDistance >= leftPos && positionX + width / 2 + componentDistance <= rightPos) && (positionY + height / 2 < topPos && positionY - height / 2 > bottomPos)) {
                isEdit = true;
            }
        }
    }

    const minLimitX = leftPos;
    const maxLimitX = rightPos;

    revertPosOfCmp(doorsArray, wallName)

    // Verify using additional functions when there is no space nearby.
    if (!isEdit) {
        // const isAvailX = (Math.abs(rightPos - leftPos) >= sideArray.reduce((acc, val) => acc + val.width, 0) + componentDistance * sideArray.length + width)
        // const isAvailDoorY = (positionY + height / 2 <= topPos);
        // const isAvailWindowY = (positionY + height / 2 <= topPos && positionY - height / 2 >= bottomPos);
        
        // if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
        //     if (isAvailX && isAvailDoorY) {
        //         isEdit = true;
        //         isChangePos = true;
        //     }
        // } else {
        //     if (isAvailX && isAvailWindowY) {
        //         isEdit = true;
        //         isChangePos = true;
        //     }
        // }

        const isAddCheck = addValidation({ compType, compName, width, height, wallName, parentkey, childkey, nestedkey, checkType: 'update_check', checkableDoorArr: sideArray }).isAdd;
        if (isAddCheck) {
            isEdit = true;
            isChangePos = true;
        }
    }
    
    return {
        isEdit, isChangePos, minLimitX, maxLimitX
    }
}

export const cupolaValidation = (length, checkType, filterCupolaArr) => {
    const offset = 0.5
    const componentDistance = const_var.componentDistance + offset;
    const sortByIdArray = const_var.cupolas.sort((a, b) => a.uniqueId - b.uniqueId);
    const cupolaCount = sortByIdArray.length > 0 ? const_var.cupolas[const_var.cupolas.length - 1].uniqueId + 1 : 0;

    let isAdd = false;
    let positionZ = 0;

    let prevPosZ = -params.p_d / 2;
    let nextPosZ = params.p_d / 2;

    const minLimitZ = -params.p_d / 2;
    const maxLimitZ = params.p_d / 2;
    
    
    const sortArray = const_var.cupolas.sort((a, b) => a.positionZ - b.positionZ);
    let newArray = [...const_var.cupolas];
    if (checkType === 'update_check') newArray = [...filterCupolaArr];

    if (sortArray.length === 0) {
        if (params.p_d > length + 2 * componentDistance) {
            isAdd = true;
            positionZ = 0;
        }
    } else {
        for (let item of sortArray) {
            if (Math.abs(item.positionZ - prevPosZ) >= item.length / 2 + 2 * componentDistance + length) {                
                positionZ = prevPosZ + (item.positionZ - item.length / 2 - prevPosZ) / 2;
                isAdd = true;
                break;
            } else {
                prevPosZ = item.positionZ + item.length / 2;
            }
        }

        if (!isAdd) {
            if (Math.abs(nextPosZ - prevPosZ) >= 2 * componentDistance + length) {
                positionZ = prevPosZ + (nextPosZ - prevPosZ) / 2;
                isAdd = true;
            } else {
                isAdd = false;
            }
        }

        if(!isAdd) {
            let isUpdate = true;

            const calculateArray = newArray.sort((a, b) => a.positionZ - b.positionZ);

            let distance = 0;
            for(let i = 0; i < calculateArray.length; i++) {
                distance = distance + calculateArray[i].length
            }
            
            if (params.p_d < distance + length + (calculateArray.length + 2) * componentDistance) {
                isUpdate = false;
            }
    
            if(isUpdate) {
                let lastDistance = 0;
                for(let i = 0; i < calculateArray.length; i++) {
                    const index = newArray.findIndex(item => item.uniqueId === calculateArray[i].uniqueId);
                    if(index !== -1) {
                        newArray[index].positionZ = -params.p_d / 2 + lastDistance + componentDistance + calculateArray[i].length / 2;
                        lastDistance = lastDistance + componentDistance + calculateArray[i].length
                    }
                }

                isAdd = true;
                positionZ = -params.p_d / 2 + lastDistance + componentDistance + length / 2
            }
        }
    }

    return {
        isAdd, positionZ, minLimitZ, maxLimitZ, cupolaCount, newArray
    }
}

export const cupolaEditValidation = (cupolaId, newLength, filterCupolaArr, currentPos) => {
    const offset = 0.5
    const componentDistance = const_var.componentDistance + offset;

    let isEdit = false;
    let isChangePos = false;
    let positionZ = 0;

    let prevPosZ = -params.p_d / 2;
    let prevWidth = 0;
    let nextPosZ = params.p_d / 2;

    const minLimitZ = -params.p_d / 2;
    const maxLimitZ = params.p_d / 2;

    const validationArray = filterCupolaArr.filter((item) => (
        item.positionZ + item.length / 2 > currentPos - newLength / 2 - componentDistance && 
        item.positionZ - item.length / 2 < currentPos + newLength / 2 + componentDistance
        )
    );

    if (validationArray.length === 0) {
        if (currentPos - newLength / 2 - componentDistance >= minLimitZ && currentPos + newLength / 2 + componentDistance <= maxLimitZ) {
            isEdit = true;
        }
    }

    if (!isEdit) {
        const isAddCheck = cupolaValidation(newLength, 'update_check', filterCupolaArr).isAdd
        if (isAddCheck) {
            isEdit = true;
            isChangePos = true;
        }
    }
    


    return { isEdit, isChangePos }
}